module.exports = __webpack_public_path__ + "static/media/risk6.8ebe3352.jpg";